import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowUpLeft: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconArrowUpLeft"><Path fillRule="evenodd" clipRule="evenodd" d="M5 6C5 5.44772 5.44772 5 6 5H15C15.5523 5 16 5.44772 16 6C16 6.55228 15.5523 7 15 7H8.41421L18.4571 17.0429C18.8476 17.4334 18.8476 18.0666 18.4571 18.4571C18.0666 18.8476 17.4334 18.8476 17.0429 18.4571L7 8.41421V15C7 15.5523 6.55228 16 6 16C5.44772 16 5 15.5523 5 15V6Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowUpLeft;
